<!--
 * @Descripttion: 育儿音频
 * @Author: hezizhao
 * @Date: 2021-01-12 15:27:02
 * @LastEditors: 李嘉辉 LiJiaHui0908
 * @LastEditTime: 2022-07-27 15:44:57
-->
<template>
  <div class="article">
    <van-list
      v-model="pageParams.loading"
      :finished="pageParams.audioFinished"
      :finished-text="bottomText"
      :error.sync="pageParams.error"
      error-text="请求失败，点击重新加载"
      @load="getDataList"
    >
      <div class="article_list collect-list">
        <div
          class="article_box"
          v-for="(item, index) in audioList"
          :key="index"
        >
          <div
            class="article_box_details"
            @click="onLinkTap(item, index, item.collectType)"
          >
            <div class="title">{{ item.name }}</div>
            <div class="time">
              <p>
                <span class="listen" v-if="item.collectType == 'ye'">
                  <img src="../../../assets/images/icon/audio_listen.png" />
                  {{ item.startDate | audioPlayDate }}
                </span>
                <span>
                  <img src="../../../assets/images/icon/audio_time.png" />
                  {{ item.durationStr || "00:00" }}
                </span>
                <span>
                  <img src="../../../assets/images/icon/audio_play.png" />
                  {{ fomatterNum(item.watchNum) || 0 }}
                </span>
              </p>
            </div>
          </div>
          <div class="audio">
            <img class="bg_img" :src="item.coverUrl" />
            <img
              class="play"
              :class="item.isPlay ? 'playing' : ''"
              :src="item.isPlay ?playDoctor : off"
              @click="startPlay(item, index)"
            />
          </div>
        </div>
      </div>
    </van-list>
    <my-music
      @addPalyNum="addPlayNum"
      v-if="audioList.length > 0"
      @pauseaudioparams="PauseaudioParams"
      @playaudioparams="PlayaudioParams"
      ref="musicAudio"
      @senDetail="senDetail"
      :playTime="playTime"
      @audio-end="audioEvenTend"
      :audioParams.sync="audioParams"
    ></my-music>
  </div>
</template>

<script>
//混入音频公共逻辑
import { audioMixins } from "@/minxs/audio.js";
import API_ from "@/utils/axiosApi/audioApi.js"; //育儿事件
import API_cage from "@/utils/axiosApi/cageChildApi.js"; //凯淇
//音频组件
import myMusic from "@/components/contents/parentingAudio/parentingAudio_1.0.vue";
import {
  getCookie,
  is_weixin,
  setCookie,
  fomatterNum,
} from "@/assets/js/common.js"; //工具类

export default {
  name: "collectAudio",
  data() {
    return {
      playId: null, //当前播放id
      type: "collect",
      // 播放时间
      playTime: 0,
      //列表数据
      audioList: [],
      //用户数据
      userInfo: {},
      //点赞状态
      likeState: false,
      //收藏状态
      cllectState: false,
      // 到底部提示语
      bottomText: "",
      // 分页参数
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        audioFinished: false,
      },
      audioParams: null, //传递音频的整体大对象（title、img、audioUrl）
      playIndex: 0,
      sensorsFlag: true, // 埋点
    };
  },
  mixins: [audioMixins],

  components: {
    myMusic,
  },

  props: {
    ABtest: {
      type: String,
      default: "",
    },
    isAudioChild: {
      type: Boolean,
    },
    isPlayAudioChild: {
      type: Boolean,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("changeIncludes", ["collection", "collectAudio"]);
    });
  },
  activated() {
    const { page, id } = this.$store.state.recordAudio;
    if (page != "" && id !== "") {
      this.pageParams.loading = true;
      this.pageParams.audioFinished = false;
      this.audioList = [];
      let pageArr = [];

      let i = 1;
      while (i <= page) {
        pageArr.push(i);
        i++;
      }

      let parama = pageArr.map((res) => {
        return new Promise((reslove) => {
          this.pageParams.page = res;
          this.getDataList("", (k) => {
            reslove(k);
          });
        });
      });

      Promise.all(parama)
        .then((result) => {
          let newaudioList = [];
          let n = 0;
          while (n <= result.length - 1) {
            newaudioList = newaudioList.concat(result[n].data.content);
            n++;
          }
          newaudioList = JSON.parse(
            JSON.stringify(newaudioList).replace(/time/g, "startDate")
          );
          newaudioList = JSON.parse(
            JSON.stringify(newaudioList).replace(/audioUrl/g, "audioAddress")
          );
          newaudioList.forEach((res) => {
            res.isPlay = false;
            res.orPlay = false;
          });
          const playStatus = sessionStorage.getItem("currentPlayStatus");
          this.audioList = newaudioList;
          const { audioTime, id } = this.$store.state.recordAudio;
          // const _index = this.audioList.findIndex((res) => res.id === id);
          const _index = this.audioList.findIndex((res) => {
            return res.id == id;
          });
          this.playIndex = _index >= 0 ? _index : 0;
          if (playStatus === "1") {
            this.playTime = audioTime;
            this.audioList[_index].isPlay = true;
          } else {
            this.audioList[_index].isPlay = false;
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.playTime = audioTime;
            }, 300);
          });

          this.audioParams = this.audioList[_index];
        })
        .catch(function(r) {
          console.log(r);
        });
    }
  },
  mounted() {
    //   获取用户信息
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    initFn() {
      this.pageParams.audioFinished = false;
      this.pageParams.error = false;
      this.pageParams.loading = false;
      this.audioList = [];
      this.pageParams.page = 1;
    },
    PlayaudioParams(obj) {
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = true;
        }
      });
      this.$forceUpdate();
    },
    PauseaudioParams(obj) {
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = false;
        }
      });
      this.$forceUpdate();
    },
    cancelPlay() {
      this.audioList[this.playIndex].isPlay = false;
      this.$refs.musicAudio.$refs.isStatus = false;
      this.$refs.musicAudio.$refs.player.pause();
    },
    senDetail() {
      this.onLinkTap(
        this.audioList[this.playIndex],
        this.playIndex,
        this.audioList[this.playIndex].collectType ||
          this.audioList[this.playIndex].audio_type
      );
    },
    //切换下一个
    audioEvenTend() {
      if (this.playIndex === this.audioList.length - 1) {
        if (this.pageParams.audioFinished) {
          this.playIndex = 0;
        } else {
          this.getDataList(1);
        }
      } else {
        this.playIndex++;
      }
      this.audioList.forEach((res, i) => {
        if (this.playIndex == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.audioParams = this.audioList[this.playIndex];
    },
    startPlay(item, index) {
      if (!item.isPlay) {
        this.audioParams = item;
        //  this.addPlayNum()
      } else {
        this.onLinkTap(item, index, item.collectType);
       
      }
      this.audioList.forEach((res, i) => {
        if (index == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.playIndex = index;
    },
    /**
     * 获取育儿音频列表数据
     * @type 布尔值为1为循环播放 2 初始化带出当前哪一页 ''初始化数据
     */
    getDataList(type = "", callback) {
      document.getElementsByClassName("article")[0].style.minHeight =
        window.innerHeight - 52 + "px";
      const crmId = this.userInfo ? this.userInfo.crm_id : "";
      API_.cllect(
        {},
        {
          crmId: crmId,
          page: this.pageParams.page,
          size: this.pageParams.size,
        },
        (res) => {
          this.pageParams.loading = false;
          if (res.code == 200) {
            var arrList = res.data.data;
            arrList.forEach((item, index) => {
              //为每一项{}添加一个播放标识 默认为false
              item.isPlay = false;
              // item.orPlay = false;
              // item.id = item.collectId;
            });
            this.audioList = this.audioList.concat(arrList);
            this.audioList = JSON.parse(
              JSON.stringify(this.audioList).replace(/time/g, "startDate")
            );
            this.audioList = JSON.parse(
              JSON.stringify(this.audioList).replace(
                /contentUrl/g,
                "audioAddress"
              )
            );

            console.log(res.data.data);
            $(".van-tabs__content").css("background", "#f2f2f2");
            if (this.pageParams.page == 1) {
              if (res.data.data.length == 0) {
                // document.getElementsByClassName('article')[0].style.paddingBottom = 0+'px'

                document.getElementsByClassName("article")[0].style.minHeight =
                  "0px";
                this.bottomText = "";
                this.$emit("isEmpty", true);
                $(".van-tabs__content").css("background", "#fff");
              } else {
                // document.getElementsByClassName('article')[0].style.paddingBottom = 70+'px'
                this.$emit("isEmpty", false);
                this.audioParams =
                  this.audioParams && this.audioParams.id
                    ? this.audioParams
                    : res.data.data[0];
              }
            }
            const HASMORE =
              res.data.total == 0 ||
              this.pageParams.page >=
                Math.ceil(res.data.total / this.pageParams.size);
            if (HASMORE) {
              this.pageParams.audioFinished = true;
              if (this.audioList.length > 0) {
                this.bottomText = "  ";
              }
            } else {
              this.pageParams.page += 1;
            }
            // type为1 判断当前播放是否到最后一页
            if (type === 1) {
              if (HASMORE) {
                this.playIndex = 0;
              } else {
                this.playIndex++;
              }
              this.audioParams = this.playAudio(this.audioList[this.playIndex]);
            }

            if (this.sensorsFlag) {
              this.sensorsFlag = false;
              sensors.track("Parenting_program_PV_UV", { Column: "育儿音频" });
            }
            callback(res);
          } else {
            this.$toast("网络异常");
            this.pageParams.loading = false;
            this.pageParams.error = true;
          }
        }
      );
    },
    addPlayNum() {
      let id = this.audioParams.id;
      if (this.playId == id) {
        return;
      }
      //collectType  kq为凯淇 ye为育儿音频
      if (this.audioParams.collectType === "kq") {
        API_cage.addPlayNum({ id: id }, (res) => {
          this.audioList[this.playIndex].play += 1;
          this.playId = id;
        });
      } else {
        API_.addPlay({}, { id: id }, (res) => {
          if (res.code == 200) {
            this.audioList[this.playIndex].play += 1;
            this.playId = id;
          } else {
            this.$toast("网络异常");
          }
        });
      }
    },
   
    // 完成任务
    taskFinish(text, relation, type) {
      var date = Date.parse(new Date());
      var string = "34f9cd73a0044a2e8d47e85de884b8b1300777";
      var taskid = "6";
      var relation = relation;
      var md5 = this.$md5(string + taskid + relation + date);
      var openid = this.getCookie("xmh_openid")
        ? this.getCookie("xmh_openid")
        : this.userInfo.memberChannel[0].account;
      this.$http.post(
        "/taskEventController/finish/xmh",
        {},
        {
          crm_id: this.userInfo.crm_id,
          task_id: "6",
          relation_id: relation,
          open_id: openid,
          timestamp: date,
          rand: md5,
        },
        (res) => {
          if (res.code == "200") {
            var taskfinish = res.data.xyz;
            this.$toast({
              duration: 2000,
              message: text + taskfinish,
              context: this,
            });
          } else {
            if (type == 3) return;
            this.$toast({
              duration: 2000,
              message: type == 1 ? "点赞成功" : "收藏成功",
              context: this,
            });
          }
        },(err) => {},'member'
      );
    },
    fomatterNum,
    getCookie,
    setCookie,
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/parenAudio.less";
</style>
